import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginCallbackComponent } from '@vinnova/auth';
import { ErrorComponent, NotFoundComponent } from '@vinnova/e-tjanster';
import { AuthGuard } from './core/guards/auth.guard';
import { AssignBedomareComponent } from './features/assign-bedomare/assign-bedomare.component';
import { FormularPreviewComponent } from './features/formular-preview/formular-preview.component';
import { StartComponent } from './features/my-profile/start/start.component';
import { PublicLayoutComponent } from './features/public/public-layout/public-layout.component';

const routes: Routes = [
  {
    path: '',
    component: StartComponent,
    children: [
      {
        path: '',
        component: StartComponent,
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'profil',
    loadChildren: () =>
      import('./features/my-profile/my-profile.module').then(
        (m) => m.MyProfileModule,
      ),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./features/my-profile/my-profile.module').then(
        (m) => m.MyProfileModule,
      ),
  },
  {
    path: 'public',
    loadChildren: () =>
      import('./features/public/public.module').then((m) => m.PublicModule),
  },
  {
    path: 'formular-test/:formId',
    data: { testable: true },
    component: FormularPreviewComponent,
  },
  {
    path: 'formular-preview/:formId',
    data: { testable: false },
    component: FormularPreviewComponent,
  },
  {
    path: 'assignbedomare',
    component: PublicLayoutComponent,
    children: [
      {
        path: '',
        component: AssignBedomareComponent,
      },
    ],
    canActivate: [AuthGuard],
  },
  {
    path: 'login-callback',
    component: LoginCallbackComponent,
  },
  {
    path: 'not-found',
    component: PublicLayoutComponent,
    children: [
      {
        path: '',
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: 'error',
    component: PublicLayoutComponent,
    children: [
      {
        path: '',
        component: ErrorComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];

/**
 * App routing module
 */
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
